// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class GlobalBreakdownChart extends ChartkickChart {
}

GlobalBreakdownChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {

});

export default GlobalBreakdownChart;
